import styled, { css } from 'styled-components'

export const StyledTotal = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: space-between;
  padding: 36px 0;
  ${({ theme }) => css(theme.variants.body2.regular)};
`

export const StyledSummaryTitle = styled.div`
  ${({ theme }) => css(theme.variants.paragraph1.regular)};
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  border-top: 1px solid ${({ theme }) => theme.color.grey};
  padding-top: 24px;
  margin-top: 24px;
  width: 100%;
`

export const StyledPricePartials = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;

  width: 100%;
`
